import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const InRun: Dashboard = {
    id: 'INRUN',
    name: 'In-Run',
    daterange: true,
    metrics: [
        {
            type: Metrics.INRUN_DWELLTIMELINE,
            'box-size': BoxSizes.BIG,
            chart: Chart.Timeline,
            title: 'dashboard-dwelltimeline',
            count: 'dashboard-count-seconds-average',
        },
        {
            type: Metrics.INRUN_CONTENT,
            'box-size': BoxSizes.BIG,
            chart: Chart.Bars,
            title: 'dashboard-inrun-content',
            count: 'dashboard-count-plays',
        },
        {
            type: Metrics.INRUN_DWELLTIME,
            'box-size': BoxSizes.MID,
            chart: Chart.Bars,
            title: 'dashboard-inrun-dwelltime',
            count: 'dashboard-count-seconds-average',
        },
        {
            type: Metrics.INRUN_STORES_TOP,
            'box-size': BoxSizes.MID,
            chart: Chart.Bars,
            title: 'dashboard-inrun-sessions-count',
            count: 'dashboard-count-sessions-average',
        },
        {
            type: Metrics.INRUN_STORES_TOP,
            'box-size': BoxSizes.MID,
            chart: Chart.List,
            title: 'dashboard-stores-top',
            count: 'dashboard-count-stores',
            'count-data': 'dashboard-count-interactions',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.MID,
            metrics: [
                {
                    type: Metrics.INRUN_CONTENT_TOP,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-content-top',
                },
                {
                    type: Metrics.INRUN_INTERACTIONS,
                    'box-size': BoxSizes.FULLWIDTH,
                    title: 'dashboard-interactions',
                },
            ],
        },
    ],
}

export default InRun
